import React from "react"
import { Check, ImageOff } from "lucide-react"
import { Button } from "src/components/ui/button"

// Picks one or many images from the project's gallery (`images` = [{id,url,filename}]).
// Single mode: value = id|null, onChange(id). Multi mode: value = [ids], onChange([ids]).
export function ImagePickerField({ images = [], value, multiple = false, onChange }) {
  if (images.length === 0) {
    return (
      <div className="flex items-center gap-2 rounded-lg border border-dashed border-slate-200 px-3 py-4 text-[13px] text-slate-400">
        <ImageOff className="h-4 w-4" />
        This project has no images yet. Add images to the project first.
      </div>
    )
  }

  const selectedIds = multiple ? value || [] : value != null ? [value] : []

  function toggle(id) {
    if (multiple) {
      const set = new Set((value || []).map(Number))
      if (set.has(id)) set.delete(id)
      else set.add(id)
      // Preserve selection order for galleries.
      const ordered = [...(value || []).map(Number).filter((x) => set.has(x))]
      if (!ordered.includes(id) && set.has(id)) ordered.push(id)
      onChange(ordered)
    } else {
      onChange(value === id ? null : id)
    }
  }

  return (
    <div className="grid grid-cols-3 gap-2">
      {images.map((img) => {
        const isSelected = selectedIds.map(Number).includes(img.id)
        const order = multiple ? selectedIds.map(Number).indexOf(img.id) : -1
        return (
          <Button
            type="button"
            variant="ghost"
            size="icon"
            key={img.id}
            onClick={() => toggle(img.id)}
            className={`relative aspect-square h-auto w-auto overflow-hidden rounded-lg border-2 p-0 hover:bg-transparent ${
              isSelected ? "border-slate-900" : "border-transparent hover:border-slate-300"
            }`}
            title={img.filename}
          >
            <img src={img.url} alt={img.filename} className="h-full w-full object-cover" />
            {isSelected && (
              <span className="absolute right-1 top-1 flex h-5 w-5 items-center justify-center rounded-full bg-slate-900 text-[10px] font-semibold text-white">
                {multiple && order >= 0 ? order + 1 : <Check className="h-3 w-3" />}
              </span>
            )}
          </Button>
        )
      })}
    </div>
  )
}
